// extracted by mini-css-extract-plugin
export var modal = "_eo-0";